export default __webpack_public_path__ + "static/train-45db8b41ea49ec40238f5817651ce42d.png";